import { toast } from 'react-toastify';
import { isEmpty } from 'validator';
import { isE2EESupported } from 'livekit-client';
import { store } from '../../store';
import i18n from '../i18n';
import { updateCurrentRoomMetadata } from '../../store/slices/sessionSlice';
import { addChatMessage } from '../../store/slices/chatMessagesSlice';
import { sleep } from '../utils';
import { handleToAddWhiteboardUploadedOfficeNewFile } from '../../components/whiteboard/helpers/utils';
export default class HandleRoomMetadata {
    constructor(that) {
        this.metadata = null;
        this.welcomeMessage = undefined;
        this.checkedE2EE = false;
        this.checkedPreloadedWhiteboardFile = false;
        this.setRoomMetadata = async (metadata) => {
            var _a, _b, _c, _d;
            if (!isEmpty(metadata)) {
                try {
                    this.metadata = JSON.parse(metadata);
                }
                catch (e) {
                    console.error(e);
                    return;
                }
                const currentId = (_b = (_a = store.getState().session.currentRoom) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.metadata_id;
                if (currentId &&
                    ((_c = this.metadata) === null || _c === void 0 ? void 0 : _c.metadata_id) &&
                    currentId === ((_d = this.metadata) === null || _d === void 0 ? void 0 : _d.metadata_id)) {
                    // if both id are same then we don't need to update
                    return;
                }
                if (this.metadata) {
                    if (!this.checkedE2EE) {
                        this.checkedE2EE = true;
                        const e2eeFeatures = this.metadata.room_features.end_to_end_encryption_features;
                        if (e2eeFeatures &&
                            e2eeFeatures.is_enabled &&
                            e2eeFeatures.encryption_key) {
                            if (!isE2EESupported()) {
                                this.that.setErrorStatus(i18n.t('notifications.e2ee-unsupported-browser-title'), i18n.t('notifications.e2ee-unsupported-browser-msg'));
                            }
                            else {
                                if (!this.that.room.isE2EEEnabled) {
                                    await this.that.e2eeKeyProvider.setKey(e2eeFeatures.encryption_key);
                                    await this.that.room.setE2EEEnabled(true);
                                }
                            }
                        }
                    }
                    this.setWindowTitle(this.metadata.room_title);
                    this.showRecordingNotification();
                    this.showRTMPNotification();
                    this.publishWelcomeMessage();
                    store.dispatch(updateCurrentRoomMetadata(this.metadata));
                    if (!this.checkedPreloadedWhiteboardFile) {
                        // we'll check whiteboard preloaded file
                        this.addPreloadWhiteboardFile();
                    }
                }
            }
        };
        this.setWindowTitle = (title) => {
            document.title = title;
        };
        this.showRecordingNotification = () => {
            var _a, _b, _c;
            // we should avoid notification is user is recorder.
            if ((_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.isRecorder) {
                return;
            }
            const isActiveRecording = store.getState().session.isActiveRecording;
            if (!isActiveRecording && ((_b = this.metadata) === null || _b === void 0 ? void 0 : _b.is_recording)) {
                toast(i18n.t('room-metadata.session-recording'), {
                    type: 'info',
                });
            }
            else if (isActiveRecording && !((_c = this.metadata) === null || _c === void 0 ? void 0 : _c.is_recording)) {
                toast(i18n.t('room-metadata.session-not-recording'), {
                    type: 'info',
                });
            }
        };
        this.showRTMPNotification = () => {
            var _a, _b, _c;
            // we should avoid notification is user is recorder.
            if ((_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.isRecorder) {
                return;
            }
            const isActiveRtmpBroadcasting = store.getState().session.isActiveRtmpBroadcasting;
            if (!isActiveRtmpBroadcasting && ((_b = this.metadata) === null || _b === void 0 ? void 0 : _b.is_active_rtmp)) {
                toast(i18n.t('room-metadata.rtmp-started'), {
                    type: 'info',
                });
            }
            else if (isActiveRtmpBroadcasting && !((_c = this.metadata) === null || _c === void 0 ? void 0 : _c.is_active_rtmp)) {
                toast(i18n.t('room-metadata.rtmp-stopped'), {
                    type: 'info',
                });
            }
        };
        this.publishWelcomeMessage = () => {
            var _a, _b, _c, _d;
            if (this.welcomeMessage !== undefined) {
                return;
            }
            if (!((_a = this.metadata) === null || _a === void 0 ? void 0 : _a.welcome_message)) {
                this.welcomeMessage = '';
                return;
            }
            if (isEmpty((_b = this.metadata) === null || _b === void 0 ? void 0 : _b.welcome_message)) {
                this.welcomeMessage = '';
                return;
            }
            this.welcomeMessage = (_c = this.metadata) === null || _c === void 0 ? void 0 : _c.welcome_message;
            const body = {
                type: 'CHAT',
                message_id: '',
                time: '',
                isPrivate: false,
                from: {
                    userId: 'system',
                    name: 'System',
                    sid: 'system',
                },
                msg: (_d = this.welcomeMessage) !== null && _d !== void 0 ? _d : '',
            };
            store.dispatch(addChatMessage(body));
        };
        this.addPreloadWhiteboardFile = async () => {
            var _a, _b, _c, _d;
            // without waiting, we won't get current user data
            await sleep(3000);
            if (!((_b = (_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.is_presenter)) {
                this.checkedPreloadedWhiteboardFile = true;
                return;
            }
            const whiteboard = (_c = this.metadata) === null || _c === void 0 ? void 0 : _c.room_features.whiteboard_features;
            if (!(whiteboard === null || whiteboard === void 0 ? void 0 : whiteboard.preload_file) || isEmpty(whiteboard === null || whiteboard === void 0 ? void 0 : whiteboard.preload_file)) {
                this.checkedPreloadedWhiteboardFile = true;
                return;
            }
            const ff = (_d = whiteboard === null || whiteboard === void 0 ? void 0 : whiteboard.preload_file) === null || _d === void 0 ? void 0 : _d.split('/');
            if (!ff) {
                return;
            }
            const fileName = ff[ff.length - 1];
            if (fileName !== (whiteboard === null || whiteboard === void 0 ? void 0 : whiteboard.file_name)) {
                this.checkedPreloadedWhiteboardFile = true;
                return;
            }
            const whiteboardFiles = store.getState().whiteboard.whiteboardUploadedOfficeFiles;
            const exist = whiteboardFiles.find((f) => f.fileId === whiteboard.whiteboard_file_id);
            if (!exist) {
                handleToAddWhiteboardUploadedOfficeNewFile(whiteboard);
            }
            this.checkedPreloadedWhiteboardFile = true;
        };
        this.that = that;
    }
}
